import { actions } from '../constants/enrollment';
import * as actionTypes from '../../models/action/enrollment';
import { IAction, IAuthInformation } from '../../models/action/core';
import { Log, Level, Logger } from 'ng2-logger';
const _logger = Log.create('Login Reducer');

// #region Enrollment Action
export function enrollmentGetAction(classId : string, activityId?: string | null) : actionTypes.IGetEnrollment {
    return {
        classId,
        activityId,
        timestamp: Date.now(),
        type: actions.ENROLLMENT_GETDATA
    };
}


export function enrollmentSetAction(enrollmentData: actionTypes.IEnrollmentData[] | null): actionTypes.ISetEnrollment {
    return {
        enrollmentData,
        timestamp: Date.now(),
        type: actions.ENROLLMENT_SETDATA
    };
}

export function enrollmentAddActionLog(actionData: actionTypes.IEnrollmentAction,callback?: (value: boolean) => void): actionTypes.IAddEnrollmentActionLog {
    return {
        actionData,
        timestamp: Date.now(),
        type: actions.ENROLLMENT_ADDACTIONLOG,
        callback
    };
}
export function enrollmentSetState(enrollmentData: actionTypes.IEnrollmentData[]): actionTypes.ISetEnrollmentStateAction {
    return {
        enrollData: enrollmentData,
        timestamp: Date.now(),
        type: actions.ENROLLMENT_SETSTATE
    };
}

export function getMyGradesGetAction(Filters: actionTypes.IFilters, spinnerId?: string, spinnerType?: 'get'|'set'): actionTypes.IGetMyGrades {
    return {
        Filters,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.GET_MY_GRADES,
    };
}

export function getMyGradesSetAction(MyGrades: actionTypes.IMyGrades[] | null, spinnerId?: string, spinnerType?: 'get'|'set',IsLastActivity?: boolean): actionTypes.ISetMyGrades {
    return {
        MyGrades,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.SET_MY_GRADES,
        IsLastActivity
    };
}

export function getRefreshMyEnrollments(spinnerId?: string, spinnerType?: 'get'|'set',) : IAction {
    return {
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.GET_REFRESH_MY_ENROLLMENTS
    };
}

export function setRefreshMyEnrollments(enrollmentData: actionTypes.IEnrollmentData[] | null): actionTypes.ISetEnrollment {
    return {
        enrollmentData,
        timestamp: Date.now(),
        type: actions.SET_REFRESH_MY_ENROLLMENTS
    };
}
// #endregion